import React from "react";
import {
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { Clear, FilterList } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import DropdownComponent from "../DropdownComponent";
import {
  applyHolidayFilters,
  updateHolidayFilters,
} from "../../redux/Thunk/holidayCalendarModule/HolidayplannerThunk";
import { STATUS_OPTIONS } from "./statusConfig";

const AvailabilityFilters = ({ isFreelancer, resourceOptions, languagesOptions, showFilters, setShowFilters, onClear }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector(state => state.root.HolidayPlannerModule);

  if (isFreelancer) return null;

  return (
    <Card sx={{ mb: 3, p: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: showFilters ? 2 : 0 }}>
        <Typography variant="h6">Filters</Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Clear Filters">
            <IconButton onClick={onClear} size="small">
              <Clear />
            </IconButton>
          </Tooltip>
          <Button
            startIcon={<FilterList />}
            onClick={() => setShowFilters(!showFilters)}
            variant="outlined"
            size="small"
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </Button>
        </Box>
      </Box>

      {showFilters && (
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs={12} md={3}>
            <DropdownComponent
              label="Linguist"
              options={resourceOptions}
              name="resource"
              value={filters.resource || ""}
              onChange={e => dispatch(updateHolidayFilters({ resource: e.target.value }))}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <FormLabel>Status</FormLabel>
              <Select
                value={filters.status || ""}
                onChange={e => dispatch(updateHolidayFilters({ status: e.target.value }))}
              >
                <MenuItem value="">All Status</MenuItem>
                {STATUS_OPTIONS.map(opt => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.short} — {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <DropdownComponent
                label="Source Language"
                options={languagesOptions}
                name="source_language"
                value={filters.sourceLanguage || ""}
                onChange={e => dispatch(updateHolidayFilters({ sourceLanguage: e.target.value }))}
              />
              <DropdownComponent
                label="Target Language"
                options={languagesOptions}
                name="target_language"
                value={filters.targetLanguage || ""}
                onChange={e => dispatch(updateHolidayFilters({ targetLanguage: e.target.value }))}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={filters.showAbsentOnly || false}
                  onChange={e =>
                    dispatch(
                      updateHolidayFilters({
                        showAbsentOnly: e.target.checked,
                        showPresentOnly: e.target.checked ? false : filters.showPresentOnly,
                      })
                    )
                  }
                />
              }
              label="Show only away (incl. partial)"
            />
            <FormControlLabel
              control={
                <Switch
                  checked={filters.showPresentOnly || false}
                  onChange={e =>
                    dispatch(
                      updateHolidayFilters({
                        showPresentOnly: e.target.checked,
                        showAbsentOnly: e.target.checked ? false : filters.showAbsentOnly,
                      })
                    )
                  }
                />
              }
              label="Show only fully available"
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              onClick={() => dispatch(applyHolidayFilters())}
              fullWidth
              startIcon={<FilterList />}
            >
              Apply
            </Button>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default AvailabilityFilters;
